import { useEffect, useState } from "react";

import { Badge } from "@/components/ui/badge";
import { apiGet } from "@/services/api";
import { formatPrice } from "@/lib/utils";

type Earnings = {
  grossSales: number;
  platformCommission: number;
  refunds: number;
  withdrawals: number;
  netEarnings: number;
  availableBalance: number;
  pendingBalance: number;
};

export function VendorHomePage() {
  const [earnings, setEarnings] = useState<Earnings | null>(null);
  const [orderCount, setOrderCount] = useState(0);
  const [productCount, setProductCount] = useState(0);
  const [vendor, setVendor] = useState<{ businessName: string; status: string; commissionRate: number } | null>(null);

  useEffect(() => {
    void apiGet<{ vendor: any }>("/api/vendors/me").then((d) => setVendor(d?.vendor ?? null));
    void apiGet<Earnings>("/api/vendors/me/earnings").then((d) => setEarnings(d));
    void apiGet<{ vendorOrders: unknown[] }>("/api/vendors/me/orders").then((d) => setOrderCount(d?.vendorOrders?.length ?? 0));
    void apiGet<{ products: unknown[] }>("/api/vendors/me/products").then((d) => setProductCount(d?.products?.length ?? 0));
  }, []);

  return (
    <div className="space-y-6">
      <div className="amazon-card p-5">
        <h2 className="text-xl font-bold">{vendor?.businessName ?? "Your store"}</h2>
        <p className="mt-1 text-sm text-slate-500">
          Status: <Badge tone={vendor?.status === "ACTIVE" ? "success" : "prime"}>{vendor?.status ?? "…"}</Badge>{" "}
          · Commission rate: <strong>{vendor?.commissionRate ?? 0}%</strong>
        </p>
      </div>

      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        <Stat label="Gross sales" value={formatPrice(earnings?.grossSales ?? 0)} />
        <Stat label="Net earnings" value={formatPrice(earnings?.netEarnings ?? 0)} />
        <Stat label="Available" value={formatPrice(earnings?.availableBalance ?? 0)} />
        <Stat label="Orders" value={String(orderCount)} />
        <Stat label="Products" value={String(productCount)} />
        <Stat label="Commission" value={formatPrice(earnings?.platformCommission ?? 0)} />
        <Stat label="Refunds" value={formatPrice(earnings?.refunds ?? 0)} />
        <Stat label="Pending payout" value={formatPrice(earnings?.pendingBalance ?? 0)} />
      </div>
    </div>
  );
}

function Stat({ label, value }: { label: string; value: string }) {
  return (
    <div className="amazon-card p-4">
      <p className="text-xs font-bold uppercase text-slate-500">{label}</p>
      <p className="mt-1 text-xl font-black">{value}</p>
    </div>
  );
}
